import { render, staticRenderFns } from "./AuctionModal.vue?vue&type=template&id=ef4f0698&scoped=true"
import script from "./AuctionModal.vue?vue&type=script&lang=ts"
export * from "./AuctionModal.vue?vue&type=script&lang=ts"
import style0 from "./AuctionModal.vue?vue&type=style&index=0&id=ef4f0698&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef4f0698",
  null
  
)

export default component.exports